export default {
  GENERATE_OTP: "candidate/generateOTP",
  LOGIN: "candidate/verifyOTP",
  OFFERDOCUMENT_DISCUSSION_CANDIDATE_COMMENT:
    "offeredDocuments/discussion/candidate",
  OFFERDOCUMENT_DISCUSSION_GET_CANDIDATE_COMMENT:
    "offeredDocuments/discussion/candidate",
  OFFERDOCUMENT_DOCUMENTS_SENDREQUESTEDDOC:
    "offeredDocuments/sendRequestedDoc/candidate",
  OFFERDOCUMENT_DOCUMENTS_FILEUPLOAD: "offeredDocuments/fileUpload",
  OFFERDOCUMENT_DOCUMENTS_FILEUPLOAD_EDIT:
    "offeredDocuments/candidate/fileDelete",

  /********** Agreements **********/
  // SIGNING_LISTING: "candidateSigningRequests/listing",
  SIGNING_LISTING: "zoho/candidate/getDocumentsBycandidate  ",
  OFFERCANDIDATE_PROFILE: "offeredCandidateProfile/",
  UPDATE_OFFERCANDIDATE_PROFILE: "offeredCandidateProfile/edit",
  GUEST_CANDIDATE_FORM: "offeredCandidate/candidateForm",
  GET_CANDIDATE_AUTH_TOKEN: "candidate/getCandidateAuthToken",
  GET_QUALIFICATION_DETAILS: "master/qualification/details",
  GET_COUNTRY_DETAILS: "master/country/details",
  GET_SKILL_SET_LIST: "master/skill/details",
  GET_HELP_DESK_DATA: "offeredCandidate/helpDesk",
  UPLOAD_CANDIDATE_RESUME: "candidate/fileupload",
  DELETE_CANDIDATE_RESUME: "candidate/fileDelete",
  UPLOAD_TEMPORARY_FILE: "candidate/temporary/fileupload",
  DELETE_TEMPORARY_FILE: "candidate/temporary/filedelete",
  ADD_COMMENT: "offeredSigningDocuments/discussion/candidate",
  COMMENT_LISTING: "offeredSigningDocuments/discussion/candidate",

  /********** job-opening ***********/
  JOB_LISTING: "candidate/getJobList",
  APPLY_JOB: "applyJobForm/candidate",
  GET_CANDIDATE_CV_DETAILS: "candidate/fetchInfo",
  GET_JOB_DETAILS: "candidate/getJobDetailsCandidate",
  MASTER_WORK_PREFERENCE_API_GET_DETAILS: "master/workPreference/details",
  ADD_SKILL_MASTER: "master/addSkill/candidate",
};
